import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { serverSessionID } from '@adornis/baseql/server/context.js';
import { getContextFromSessionID } from '@adornis/baseql/server/getContext.js';
import { mongo } from '@adornis/buchungsheld-db/server/mongo.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { setUserOnContext } from '@adornis/users/server/baseqlContextHelper.js';
import type { Document, WithId } from 'mongodb';
import { onlyDevAndQaGuard, onlyDevGuard } from '../resolver-guard.js';

export const getUsersDebug: (search: string) => (gqlFields: any) => Promise<WithId<Document>[]> = registerQuery({
  operationName: 'getUsersDebug',
  params: [{ name: 'search', type: () => String }],
  type: () => [AdornisUser],
  resolve: (search: string) => gqlFields => {
    if (baseConfig.get('DEPLOYMENT') !== 'development') {
      throw new Error('This operation is only allowed in development');
    }
    const userCollection = mongo().collection(AdornisUser._collectionName);
    return userCollection
      .find({ email: { $regex: search, $options: 'i' } })
      .limit(20)
      .toArray();
  },
  middlewares: [onlyDevAndQaGuard],
});

export const loginUserDebug = registerMutation({
  operationName: 'loginUserDebug',
  params: [{ name: 'user', type: () => AdornisUser }],
  type: () => AdornisUser,
  resolve: (user: AdornisUser) => async gqlFields => {
    if (baseConfig.get('DEPLOYMENT') !== 'development') {
      throw new Error('This operation is only allowed in development');
    }

    setUserOnContext(user);

    const context = getContextFromSessionID(serverSessionID);
    if (!context) throw new Error('cannot determine context');

    return user;
  },
  middlewares: [onlyDevGuard],
});
